import api from './axios';

export const createOrder = (body) => api.post('/orders', body).then((r) => r.data);

export const fetchOrders = (params) => api.get('/orders', { params }).then((r) => r.data);

export const fetchOrderSuggestions = (params) =>
  api.get('/orders/suggestions', { params }).then((r) => r.data);

export const fetchOrder = (id) => api.get(`/orders/${id}`).then((r) => r.data);

export const fetchOrderSummary = () => api.get('/orders/summary').then((r) => r.data);

export const confirmOrder = (id) => api.put(`/orders/${id}/confirm`).then((r) => r.data);

export const updateOrderStatus = (id, status, note) =>
  api.put(`/orders/${id}/status`, { status, note }).then((r) => r.data);

export const confirmOrderDelivery = (id) =>
  api.put(`/orders/${id}/confirm-delivery`).then((r) => r.data);

export const rejectOrder = (id, rejectionReason) =>
  api.put(`/orders/${id}/reject`, { rejectionReason }).then((r) => r.data);

export const uploadPaymentSlip = (id, file, { bankAccountId, onProgress } = {}) => {
  const fd = new FormData();
  fd.append('file', file);
  if (bankAccountId) fd.append('bankAccountId', bankAccountId);
  return api
    .post(`/orders/${id}/payment-slip`, fd, {
      headers: { 'Content-Type': 'multipart/form-data' },
      onUploadProgress: onProgress,
    })
    .then((r) => r.data);
};

export const verifyPaymentSlip = (id, slipIndex) =>
  api.put(`/orders/${id}/payment-slip/${slipIndex}/verify`).then((r) => r.data);

export const sendOrderChat = (id, message) =>
  api.post(`/orders/${id}/chat`, { message }).then((r) => r.data);

export const adjustOrderPrice = (id, body) =>
  api.put(`/orders/${id}/adjust-price`, body).then((r) => r.data);
